export const environment = {
  envName: 'prod',
  production: true,
  APIURL: 'https://pts.dubaicharity.ae/app/api/',
  defaultLanguage: 'ar',
  supportedLanguages: ['en', 'ar'],
  googleMapApiKey: 'AIzaSyCIlhsH1PuSagJZfSba34m0LXUqwOIvq7Q',
  DefaultPagerPageSize: 10,
  pageNumber: 1,
  pageSize: 10,
};
